import { useContext } from 'react'
import { BrandContext } from './BrandContext'
import type { BrandConfig } from './types'

/**
 * Returns the active brand configuration.
 * Must be called inside a component rendered within `<BrandProvider>`.
 */
export const useBrand = (): BrandConfig => {
  const ctx = useContext(BrandContext)
  if (!ctx) throw new Error('useBrand must be used inside <BrandProvider>')
  return ctx
}
